import BigButtons from './BigButtons'

export default BigButtons
